import * as React from "react";
import {Card, Alert, Col, Row} from "react-bootstrap";
import { Project } from "../../../interfaces/Project";
import { Link } from "react-router-dom";

interface IProps {
    project: Project
}

export default ({project} : IProps) => (
    <React.Fragment>
        <div className="warning-zone p-4 mb-4">
                <Alert variant="danger" className="mb-0 weather-warning">
                    <div className="d-flex align-items-center">
                            <div className="mr-4 left">
                                <i className="fas fa-exclamation-triangle" />
                            </div>
                            <div className="middle">
                                <p className="font-weight-bold p-0 m-0">Weather warning!</p>
                                <p className="p-0 m-0">Some other message</p>                   
                            </div>
                    </div>
                </Alert>
            </div>
            <div className="px-3">
                <Row>
                    <Col md={8} xs={12}>
                        <Row>
                            <Col>
                                <Card className="my-3">
                                    <Card.Header className="pb-0">
                                        <h3 className="mb-0">{project.name}</h3>
                                        <small className="text-muted font-weight-bold">Project description</small>
                                    </Card.Header>
                                    <Card.Body className="pt-0">
                                        <p>{project.description}</p>                                            
                                        <p>something is here</p>                                    
                                    </Card.Body>
                                </Card>

                                <Card className="my-3 site-status">
                                    <Card.Body>
                                        <Row>
                                            <Col>
                                                <Row className="p-4">
                                                    <Col md={3}>
                                                        <img src={require("../../../assets/workers.svg")} />
                                                    </Col>
                                                    <Col>
                                                        <span className="font-weight-bold">People on site</span>
                                                        <Row>
                                                            <Col>7</Col>
                                                            <Col><span className="text-muted">Active</span></Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>14</Col>
                                                            <Col><span className="text-muted">Total</span></Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col>
                                                <Row className="p-4">
                                                    <Col>
                                                        <img src={require("../../../assets/equipment.svg")} />                                                                    
                                                    </Col>
                                                    <Col>
                                                        <span className="font-weight-bold">Equipment</span>
                                                        <Row>
                                                            <Col>7</Col>
                                                            <Col>Active</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>14</Col>
                                                            <Col>Total</Col>
                                                        </Row>
                                                    </Col>
                                                </Row>                                                    
                                            </Col>
                                            <Col>
                                                <div className="p-4 d-flex align-items-center flex-column">
                                                    <Row>
                                                        <Col>
                                                            <p className="font-weight-bold">Machinery status</p>                                                                   
                                                        </Col>
                                                    </Row>   
                                                    <Row>
                                                        <Col>
                                                            <i className="fas fa-check-circle" />                                                      
                                                        </Col>
                                                    </Row>   
                                                </div>
                                            </Col>
                                        </Row>    
                                        <Row>
                                            <Col>
                                                <div className="p-4">                                                
                                                    <Row>
                                                        <Col>
                                                            <p>Alerts</p>                                                                   
                                                        </Col>
                                                    </Row>   
                                                    <Row>
                                                        <Col>
                                                            <i className="fas fa-check-circle" />                                                      
                                                        </Col>
                                                        <Col>
                                                            Weather warning
                                                        </Col>
                                                    </Row>   
                                                    <small className="text-muted">Updated: date</small>
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="p-4">
                                                    <Row>
                                                        <Col>
                                                            <img src={require("../../../assets/reports.svg")} />    
                                                        </Col>
                                                        <Col>
                                                            <p>Latest report generated: 1/03/2020</p>                                                                   
                                                        </Col>
                                                    </Row>     
                                                    <Link to="/reports">
                                                        View report
                                                    </Link>
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="d-flex align-items-center h-100 p-4">
                                                    <i className="fas fa-plus-circle" />    
                                                    <span className="pl-2">Edit reports</span>
                                                </div>                                                   
                                            </Col>
                                        </Row>                        
                                    </Card.Body>
                                </Card>


                                <Card className="my-3">
                                    <Card.Header>
                                        Project schedule 
                                    </Card.Header>
                                    <Card.Body>
                                        <p>Calender</p>  
{/* 
                                        {
                                            this.state.calender.map(day => (
                                                <p>{day}</p>
                                            ))
                                        } */}



                                    </Card.Body>
                                </Card>

                            </Col>
                            <Col>
                                
                                <Card className="my-3">
                                    <Card.Body>
                                        <p>Map</p>
                                    </Card.Body>
                                </Card>
                            
                            </Col>
                        </Row>    
                    </Col>
                </Row>
            </div>
    </React.Fragment>
)